<template>
  <footer class="block-footer footer" :class="[device_platform]">
    <div class="container">
      <p class="footer__text">ФитнесМания © 2021</p>
    </div>

    <a href="/offer.pdf" target="_blank" class="footer__link">Оферта</a>

    <block-legal
        v-for="(item, i) of legal" :key="i"
        :title="item.title"
        :text="item.text"
    />
    
  </footer>
</template>

<script>
import Mixin from "../common/mixin";
import BlockLegal from "./block-legal.vue";
import disclaimer from "@/common/disclaimer";

export default {
  name: "block-footer",
  mixins: [Mixin],
  components: {BlockLegal},
  data(){
    return{
      legal: [
        {
          title: 'Политика обработки данных',
          text: disclaimer,
        }
      ],
    }
  }
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

.footer {
  width: 100%;
  padding: 16px 0;
  position: relative;
  background-color: #fff;

  &__link {
    display: block;
    width: max-content;
    border-bottom: 1px solid $primary;
    margin: 1em auto 0;
  }

  &__text {
    font-size: 14px;
    color: #a0a0a0;
    letter-spacing: 0.05em;
    text-align: center;
  }
  &__phone {
    position: absolute;
    top: 50%;
    left: 6%;
    transform: translateY(-50%);
  }
}
@media (max-width: 476px) {
  .footer {
    &__phone {
      position: static;
      text-align: center;
      display: block;
    }
  }
}
</style>
